import clsx from "clsx";
import { motion } from "framer-motion";

import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { useQuery } from "urql";
import { DimensionObject } from "../../hooks/useDimensions";
import { GET_CATEGORY_INFO } from "../../queries/getCategoryInfo.gql";
import { CategoryTree, Query, StrapiCmsMenuItem } from "../../queries/graphql";
import Mask from "../Mask";
import Modal from "../Modal";
import * as classes from "./desktopMenu.module.scss";
import { DesktopMenuRight } from "./desktopMenuRight";
interface IComponentProps {
  menuData: StrapiCmsMenuItem[];
  isOpen: boolean;
  closeModal: () => void;
  dimensions: DimensionObject;
}

const DesktopMenuLeft = ({
  item,
  setActiveItem,
}: {
  item: StrapiCmsMenuItem;
  setActiveItem: Dispatch<SetStateAction<StrapiCmsMenuItem>>;
}) => {
  const [{ data, fetching }] = useQuery<Query>({
    query: GET_CATEGORY_INFO,
    variables: { id: item.CategoryId },
  });
  if (!data) {
    return (
      <a className={classes.title}>
        <Skeleton width={150} height={40}></Skeleton>
      </a>
    );
  }
  return (
    <a
      href={`/${data?.category?.url_path}`}
      className={classes.title}
      onKeyPress={() => {
        setActiveItem(item);
      }}
      onMouseOver={() => {
        setActiveItem(item);
      }}
    >
      {item.Title}
    </a>
  );
};
const ChildItem = ({ item }: { item: StrapiCmsMenuItem }) => {
  const categoryId = item.CategoryId;
  const [{ data, error }] = useQuery<{ category: CategoryTree }>({
    query: GET_CATEGORY_INFO,
    variables: {
      id: categoryId,
    },
  });
  const targetLink = data?.category?.url_path;
  if (!targetLink) {
    return (
      <a href="#" className={classes.childTitle}>
        <Skeleton width={100}></Skeleton>
      </a>
    );
  }
  return (
    <a key={item.id} href={`/${targetLink}`} className={classes.childTitle}>
      {item.Title}
    </a>
  );
};
export const DesktopMenu = (props: IComponentProps) => {
  const { menuData, isOpen, closeModal, dimensions } = props;
  const [activeItem, setActiveItem] = useState<StrapiCmsMenuItem>();
  useEffect(() => {
    setActiveItem(menuData.find((el) => true));
  }, [menuData]);
  return (
    <Modal>
      <motion.div
        initial={{
          height: 0,
          opacity: 0,
        }}
        style={{
          translateY: dimensions.bottom,
        }}
        variants={{
          open: {
            opacity: 1,
            height: "auto",
          },
          closed: {
            height: 0,
            zIndex: -1,
            transition: {
              delay: 0.5,
            },
          },
        }}
        transition={{ ease: "easeIn" }}
        className={classes.root}
        animate={isOpen ? "open" : "closed"}
      >
        <div className={classes.innerGrid}>
          <div className={classes.leftArea}>
            <div className={classes.leftAreaContent}>
              {menuData
                .filter((el) => el.Visible)
                .sort((a, b) => a.RelativePosition - b.RelativePosition)
                .map((menuItem) => {
                  const directChildren = menuItem.menu_children.filter(
                    (el2) => el2.ShowUnderParent
                  );
                  return (
                    <div
                      className={clsx(classes.item, {
                        [classes.active]: activeItem?.id == menuItem.id,
                      })}
                      key={menuItem.id}
                      data-position={menuItem.RelativePosition}
                    >
                      <DesktopMenuLeft
                        item={menuItem}
                        setActiveItem={setActiveItem}
                      ></DesktopMenuLeft>
                      {directChildren.length > 0 && (
                        <div className={classes.childItems}>
                          {directChildren.map((childItem) => (
                            <ChildItem key={childItem.id} item={childItem} />
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })}
            </div>
          </div>
          {activeItem && (
            <motion.div
              initial={{ translateX: 5 }}
              animate={{ translateX: 0 }}
              transition={{ duration: 0.3 }}
              key={activeItem.id}
              className={classes.rightArea}
            >
              <DesktopMenuRight item={activeItem}></DesktopMenuRight>
            </motion.div>
          )}
        </div>
      </motion.div>
      <Mask
        isActive={isOpen}
        classes={{ root: classes.maskRoot }}
        dismiss={() => {
          closeModal();
        }}
        delayedDismiss={() => {
          setTimeout(() => closeModal(), 350);
        }}
      />
    </Modal>
  );
};
